// Base URL API back-office ioUman (authentification admin requise).
//
// Surchargeable au build via REACT_APP_API_URL (cf. .env.example). La valeur
// par défaut pointe sur le service Render `health-ssb7`.
//
// Note CORS : l'origin du BO (https://admin.iou-man.com en prod,
// http://localhost:3000 en dev) doit être présente dans la variable
// CORS_ALLOWED_ORIGINS du backend, sinon le navigateur bloque toutes les
// requêtes dès le preflight.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://health-ssb7.onrender.com/api/v1";

// Origin du backend (sans le suffixe /api/v1) — utile pour les endpoints
// montés hors du préfixe versionné (ex. /api/admin/mail).
export const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE_URL).origin;
  } catch (_) {
    return API_BASE_URL.replace(/\/api\/v1\/?$/, "");
  }
})();

export default API_BASE_URL;
